import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Image, Icon, Container, Grid, Button, Divider, Header } from 'semantic-ui-react';
import { calculateWin } from '../CreateStake/OddsSlider';

import history from '../../history';
import './ViewStake.css';
import logo from '../../assets/logo.svg';

import { STATUS, getStatusTitle, getStatusText } from '../../utils/status';


// 5000 STAKE = £100
const exchangeRate = 0.02;

class ViewStake extends Component {
  static propTypes = {
    stake: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    actions: PropTypes.node
  };

  constructor(props){
    super(props);
    const { stake, user } = this.props;

    this.state = {
      isDraft: stake.status === STATUS.Draft,
      isWin: stake.status === STATUS.Settled && stake.winner === user.sub,
      isLoss: stake.status === STATUS.Settled && stake.winner !== user.sub
    };
  }

  componentWillMount() {
    document.body.classList.toggle('grey-bg', true);
  }
  componentWillUnMount() {
    document.body.classList.remove('grey-bg');
  }

  goBack = () => {
    history.push({
      pathname: '/',
      search: this.state.isDraft ? '?draft=1' : ''
    });
  };

  render() {
    const { user, stake, availableBalance } = this.props;
    const { status } = stake;

    const isMyStake = this.state.isDraft ? true : stake.isMyStake;
    const opponent = isMyStake ? stake.stakeeProfile : stake.stakerProfile;

    const stakerWins = calculateWin(stake.amount, stake.odds);
    const winAmount = isMyStake ? stakerWins : stake.amount;
    const loseAmount = isMyStake ? stake.amount : stakerWins;

    const statusTitle = getStatusTitle(stake, status, user);

    const contentClass = status === STATUS.RequestCancel || status === STATUS.Nullified ? 'fade' : '';

    const isEdited = stake.status === STATUS.Reissued;

    const titleClass = isEdited && stake.editedFields.includes('title') ? 'edited' : '';
    const rulesClass = isEdited && stake.editedFields.includes('rules') ? 'edited' : '';
    const amountClass = isEdited && stake.editedFields.includes('amount') ? 'edited' : '';

    const winClass = isEdited && (stake.editedFields.includes('amount') || 
    (stake.editedFields.includes('odds') && isMyStake)) ? 'edited' : '';

    const loseClass = isEdited && (stake.editedFields.includes('amount') || 
      (stake.editedFields.includes('odds') && !isMyStake)) ? 'edited' : '';
      
    return (
      <section id="ViewStake">
        <nav>
          <Header as="div" floated="left" className="back-button" onClick={this.goBack}>
            <Icon link name="angle left" />
          </Header>
          <div id="balance-info">
            <div className="sub">Available Balance</div>
            <div className="title">
              {availableBalance} <span className="sub">{stake.currency}</span>
            </div>
            <div className="sub">£{availableBalance * exchangeRate}</div>
          </div>
        </nav>

        <section id="stake-card">
          <Container className={contentClass}>
            <div className={`title ${titleClass}`}>{stake.title}</div>
            <p className={`rules ${rulesClass}`}>{stake.rules}</p>
          </Container>

          {/* <div className={`status-banner ${stake.status}`}>{stake.status}</div> */}
          <div className={`status-banner ${statusTitle.replace(' ', '')}`}>
            {statusTitle.toUpperCase()}
            <div className="sub">{getStatusText(stake, opponent.name, user)}</div>
          </div>

          <Container text>
            <div className={contentClass}>
              <p className="sub">Staked amount</p>
              <div className={`title ${amountClass}`}>
                {stake.amount} {stake.currency}
              </div>
              <Divider />

              <Grid id="versus" centered verticalAlign="middle" columns={3}>
                <Grid.Column width={6} textAlign="right">
                  <span className="user left">
                    {user.nickname} <Image src={user.picture} avatar />
                  </span>
                </Grid.Column>
                <Grid.Column width={3}>
                  <div className="logo">
                    <Image src={logo} />
                  </div>
                </Grid.Column>
                <Grid.Column width={6} textAlign="left">
                  <span className="user">
                    <Image src={opponent.avatar} avatar /> {opponent.name}
                  </span>
                </Grid.Column>
              </Grid>

            {!this.state.isLoss && 
              <div className="criteria-card win">
                <div>
                  <span className="title">You win</span>
                  <div className="amount">
                    <span className={winClass}>
                      +{winAmount} {stake.currency}
                    </span>
                  </div>
                </div>
                <p className="criteria sub">{}</p>
              </div>
            }

            {!this.state.isWin && 
              <div className="criteria-card lose">
                <div>
                  <span className="title">You lose</span>
                  <div className="amount">
                    <span className={loseClass}>
                      -{loseAmount} {stake.currency}
                    </span>
                  </div>
                </div>
                <p className="criteria sub">{}</p>
              </div>
            }
              <div className="title adjudication">Adjudication</div>
              <Button as="div" fluid basic color="blue" className="adjudication-type">
                Simple
              </Button>
              <p>Completion requires mutual agreement</p>
            </div>

            <div className="actions">{this.props.actions}</div>
          </Container>
        </section>
      </section>
    );
  }
}

const mapStateToProps = ({ auth, app }) => ({
  user: auth.profile,
  availableBalance: app.availableBalance
});

export default connect(mapStateToProps)(ViewStake);



// WEBPACK FOOTER //
// ./src/App/ViewStake/ViewStake.js